import {
  BuildingOffice2Icon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  CogIcon,
  PresentationChartLineIcon,
  BanknotesIcon,
  GiftIcon,
} from '@heroicons/react/24/outline';

/**
 * Shared onboarding tasks configuration
 * This is the single source of truth for onboarding tasks across the app
 * Synced with DEFAULT_ONBOARDING_TASKS in lib/emailTemplates.js
 */
/**
 * Get navigation link for a task
 * @param {Object} taskConfig - The task configuration
 * @param {Object} company - Company object with fields (Domain, Name)
 * @returns {string} Navigation link
 */
export const getTaskLink = (taskConfig, company) => {
  // If link is a function, call it with company for dynamic links
  if (typeof taskConfig.link === 'function') {
    return taskConfig.link(company);
  }
  // Otherwise, return the link string
  return taskConfig.link || '#';
};

export const ONBOARDING_TASKS_CONFIG = [
  { 
    name: 'Complete Profile', 
    benefit: 'Input company info to prioritize your upgrades by highest $ value, lowest risk, lowest effort, & quickest wins first',
    time: '3 - 10 min',
    icon: BuildingOffice2Icon,
    link: '/company-info-section',
  },
  { 
    name: 'Upload or Integrate Expenses', 
    benefit: 'Save $15,000 - $200,000/yr (30% - 80% savings on qualifying expenses)',
    time: '3 - 10 min',
    icon: CurrencyDollarIcon,
    link: '/software-savings',
  }, 
  { 
    name: 'Redeem Savings',
    benefit: 'Save $5,000 - $50,000/yr (10% - 50% savings on software)',
    time: '3 - 10 min',
    icon: CurrencyDollarIcon,
    link: '/software-savings',
  },
  { 
    name: 'Add to My Grants',
    benefit: 'Earn $104,803/yr avg ($22.5k/grant × ~4.4 avg wins, 88% win rate if qualified + on time)',
    time: '3 - 10 min',
    icon: DocumentTextIcon,
    link: '/all-grants',
  }, 
  { 
    name: 'Try 3 AI Automations',
    benefit: 'Earn +$55,000/yr avg per AI automation — money-back guarantee',
    time: '10 min',
    icon: CogIcon,
    link: '/ai-automations',
  },
  { 
    name: 'Try 3 Revenue Upgrades',
    benefit: 'Stack 3 proven revenue AIs to add +$150,000/yr in pipeline - money-back guarantee.',
    time: '15 min',
    icon: PresentationChartLineIcon,
    link: '/revenue-upgrades',
  },
  { 
    name: 'Ideal Client Intro', 
    benefit: 'Free intro. ~20% win rate (avg $50,000+ new revenue/client)',
    time: '2 min',
    icon: BanknotesIcon,
    link: '/my-network?mode=intros',
  },
  { 
    name: 'Refer & Earn More', 
    benefit: 'Earn up to $3,000 per referral',
    time: '2 min',
    icon: GiftIcon,
    link: '/my-network',
  },
];

